import { defineStore } from "pinia";
import { ref } from "vue";

import { asReadonly } from "@/utils/vue";

import { toggleFunc } from "./helpers/toggle";

export const useSwitchSessionStore = defineStore("switchSession", () => {
  const active = ref(false);

  return {
    active: asReadonly(active),
    toggle: toggleFunc(active),
  };
});
